module.exports = "/assets/fa561e248d3c6570317ca1fc814442bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/booking-com-icon.jpg
// module id = 614
// module chunks = 0